export default __webpack_public_path__ + "static/media/error.c9e62e2f.png";